import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {Calendar} from 'primeng/calendar';
import {LoggerService} from '../../../logging/services/logger.service';
import {LogLevel} from '../../../logging/data/logLevel';
import {LogSourceType} from '../../../logging/data/logSourceType';
import {LogSource} from '../../../logging/data/logSource';

@Component({
  selector: 'w-time-field',
  templateUrl: './time-field.component.html',
  styleUrls: ['./time-field.component.scss']
})
export class TimeFieldComponent implements OnInit, OnChanges {
  stringValue: string;
  mockValue: Date;
  @Input() value: Date;
  @Output() valueChange: EventEmitter<Date> = new EventEmitter<Date>();
  @ViewChild('calendar', { static: false }) calendar: Calendar;
  @Input() label: string;
  @Input() hideLabel: boolean = false;

  constructor(private loggingService: LoggerService) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.value = changes.value.currentValue;
    this.mockValue = this.value;
  }


  timeHandler(calendarId: string) {
    const input = this.calendar.el.nativeElement;
    const actualInput = input.getElementsByTagName('input')[0];

    if (!this.value && (!actualInput.value || actualInput.value.length === 0)) {
      return;
    }

    this.stringValue = actualInput.value;

    // else {
    //   // primeng calendar parsed the time successfully
    //   return;
    // }

    const normalFormatting = /^(0[1-9]|1[0-2]|[1-9]):([0-5][0-9]) ((a|p)m|(A|P)M)$/;
    // const normalFormatting = /^(0?[1-9]|1[0-2]):([0-5]\d)\s?(AM|A\.M\.|am|a\.m\.|PM|P\.M\.|pm|p\.m\.)$/;
    const shortFormatting = /^([1-9]|1[0-2]) ([0-5][0-9]) ((a|p)|(A|P))$/;
    const shortFormatting2 = /^([1-9]|1[0-2]) ([0-5][0-9]) ((a|p)m|(A|P)M)$/;
    let checkFormat = false;

    if ( normalFormatting.test(this.stringValue)){
      checkFormat = true;
    }
    else {
      if ( (shortFormatting.test(this.stringValue) || shortFormatting2.test(this.stringValue)) && !checkFormat) {
        checkFormat = true;
      }
      else {
        this.stringValue = '00:00 AM';
        checkFormat = true;
      }
    }

    const splittedTime = this.stringValue.split( ' ');

    if (splittedTime.length === 3 && (splittedTime[2].toLowerCase() === 'p' || splittedTime[2].toLowerCase() === 'a' || splittedTime[2].toLowerCase() === 'am' || splittedTime[2].toLowerCase() === 'pm')) {
      let hours: string = splittedTime[0];
      if (hours.length < 2) {
        hours = '0' + hours;
      }

      let minutes: string = splittedTime[1];
      if (minutes.length <= 1) {
        minutes = '0' + minutes;
      }

      this.stringValue = hours + ':' + minutes + ' ' + (splittedTime[2].toLowerCase() === 'a' || splittedTime[2].toLowerCase() === 'am' ? 'AM' : 'PM');
    }
    else {
      if (splittedTime.length === 1 && (splittedTime[0].slice(-2).toLowerCase() === 'am' || splittedTime[0].slice(-2).toLowerCase() === 'pm')) {
        this.stringValue = this.stringValue.substring(0, this.stringValue.length - 2) + ' ' + this.stringValue.slice(-2).toUpperCase();
      }

      if (splittedTime.length === 2 && (splittedTime[1].slice(-2).toLowerCase() === 'am' || splittedTime[1].slice(-2).toLowerCase() === 'pm')) {
        if (splittedTime[0].length === 4){
          this.stringValue = '0' + splittedTime[0] + ' ' + splittedTime[1].toUpperCase();
        }
        else{
          this.stringValue = splittedTime[0]  + ' ' + splittedTime[1].toUpperCase();
        }
      }
    }

    let formatHours = parseInt(this.stringValue.substr(0, 2));
    const formatMinutes = parseInt(this.stringValue.substr(3, 2));

    if (this.stringValue.slice(-2) === 'PM') {
      formatHours += 12;
    }

    if (formatHours === 24) {
      formatHours = 0;
    }

    this.value.setHours(formatHours);
    this.value.setMinutes(formatMinutes);
    this.mockValue = this.value;
    this.valueChange.emit(this.mockValue);
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.TimeFieldComponent, 'Formatted time: ' + this.mockValue);
  }

  calendarFocus(calendarId: string) {
    // at the time of writing this, there was a bug with primeng calendar, which required two tab presses
    // for tabbing into the date input, so I had to manually select the input inside the component for tabbing with this event

    const input = this.calendar.el.nativeElement;
    const actualInput = input.getElementsByTagName('input')[0];

    actualInput.focus();
    actualInput.select();
  }

  timeSelect($event: any) {
    this.value = $event;
    this.mockValue = $event;
    this.valueChange.emit(this.value);
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.TimeFieldComponent, 'Selected time:' + this.value);
  }
}
